import { InventoryItem, SmartAssemblyType } from "@eveworld/types";
import { EveButton } from "@eveworld/ui-components";

import { findOwnerByAddress } from "@eveworld/utils";
import { useSmartObject, useNotification } from "@eveworld/contexts";

import { useWorldContract } from "../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import executeHeadHunters from "./systemCalls/handleExecuteHeadHunters";

interface Props {
  ephemeralInventoryItem: InventoryItem;
}

const InventoryListItem = ({ ephemeralInventoryItem }: Props) => {
  const { smartCharacter } = useSmartObject();
  const { smartAssembly } = useSmartObject();
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  var errorMessage = "";

  var smartStorageUnit = smartAssembly as SmartAssemblyType<"SmartStorageUnit">;

  var ephemeralInventoryList =
    smartStorageUnit.inventory.ephemeralInventoryList;

  const playerInventory = ephemeralInventoryList.find((x) =>
    findOwnerByAddress(x.ownerId, smartCharacter.address)
  );

  if (smartAssembly === undefined || smartAssembly === null) return <></>;

  const handleClaimPoints = async (itemId: number) => {
    if (playerInventory) {
      var ephemeralInventoryItems = playerInventory.ephemeralInventoryItems;
      if (ephemeralInventoryItems) {
        try {
          ephemeralInventoryItems.forEach(async (ephemeralInventoryItem) => {
            if (
              ephemeralInventoryItem.itemId == itemId &&
              ephemeralInventoryItem.quantity > 0
            ) {
              const txHash = await executeHeadHunters({
                worldContract,
                smartObjectId:
                  smartAssembly?.id || import.meta.env.VITE_SMARTASSEMBLY_ID,
                quantity: ephemeralInventoryItem.quantity,
                itemId: ephemeralInventoryItem.itemId,
                smartCharacterName: smartCharacter.name,
              });
              if (txHash) {
                notify({ type: Severity.Success, txHash });
              } else {
                notify({
                  type: Severity.Error,
                  message: "Transaction failed to execute",
                });
                errorMessage = "Transaction failed to execute";
                return;
              }
            }
          });

          errorMessage =
            "Process complete, check the leader board to see how you compare!";
          //console.info(errorMessage);

          return;
        } catch (e: any) {
          errorMessage = e.message;
          // console.error(errorMessage);
        }
      }
    }
  };

  return (
    <>
      <tr style={{ width: "100%" }}>
        {/* <td style={{ width: "80px", height: "80px", paddingLeft: "15px" }}>
          <img
            src={ephemeralInventoryItem.image?.replace(
              "https://sandbox-garnet-ipfs-gateway.nursery.reitnorf.com/ipfs/",
              "https://mainnet-game-ipfs-gateway.nursery.reitnorf.com/ipfs/"
            )}
          ></img>
        </td> */}
        <td
          style={{
            width: "calc(100% - 200px)",
            height: "80px",
            paddingLeft: "15px",
          }}
        >
          {/* {ephemeralInventoryItem.quantity} units of{" "} */}
          {/* {ephemeralInventoryItem.name} */}
          {ephemeralInventoryItem.quantity} Strangers Head(s)
        </td>
        <td>
          <EveButton
            typeClass="primary"
            className="primary-sm"
            style={{
              width: "175px",
            }}
            onClick={() => handleClaimPoints(ephemeralInventoryItem.itemId)}
            disabled={false}
            id="ClaimPoints"
          >
            Claim {Math.floor(ephemeralInventoryItem.quantity)} Point(s)
          </EveButton>
        </td>
      </tr>
    </>
  );
};

export default InventoryListItem;
